import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { take, filter, switchMap, map } from 'rxjs/operators';
import { getOneClickHaulers } from '@ordersnproducts/modules/one-click-order/selectors/one-click-haulers.selector';
import { OneClickSelectHaulerAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-hauler.actions';

@Injectable()
export class OneClickSetHauler implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickHaulers)
        .pipe(
          filter((haulers) => !!haulers.length),
          take(1),
          map((haulers) => haulers.find((item) => item.haulerId === value)),
          switchMap((hauler) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, hauler })),
            ),
          ),
        )
        .subscribe(({ order, hauler }) => {
          const orderUpdated = {
            ...order,
            shippingHauler: {
              shippingHaulerCode: hauler.haulerCode,
              shippingHaulerDesc: hauler.haulerDesc,
              shippingHaulerId: hauler.haulerId,
            },
          } as any as Order;
          this.store.dispatch(new OneClickSelectHaulerAction(hauler));
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        });
    }
  }
}
